import onCloseInlineCompose from './onCloseInlineCompose';
import { getStore } from '../store/composeStore';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { lazyClosePreview } from 'owa-preview-pane-store';
import { action } from 'satcheljs/lib/legacy';

export default action('pendCompose')(function pendCompose() {
    const store = getStore();
    if (store.primaryComposeId && !store.pendingComposeId) {
        const viewState = store.viewStates.get(store.primaryComposeId);
        if (viewState.isInlineCompose) {
            onCloseInlineCompose(viewState.conversationId);
        } else {
            mailModuleOrchestrator.lazyOnCloseCompose.importAndExecute();
        }
        store.pendingComposeId = store.primaryComposeId;
        store.primaryComposeId = null;
        lazyClosePreview.importAndExecute('pendCompose');
    }
});
